import React, { useEffect, useState } from 'react';
import { Prompt, useHistory, useLocation } from 'react-router';
import { useModals, MODAL_TYPE } from '../../hooks/useModal';

export function RouterPrompt({ when }) {
    const { showModal } = useModals();
    const location = useLocation();
    const history = useHistory();
    const [lastLocation, setLastLocation] = useState(location);
    const [shouldUnload, setShouldUnload] = useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);

    const handleBlockedRoute = nextLocation => {
        if (!confirmedNavigation) {
            showModal(MODAL_TYPE.UNSAVED_MODIFICATIONS, { setConfirmedNavigation });
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    };

    // Block react routes
    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            // Navigate to the previous blocked location with your navigate function
            setShouldUnload(true);
            history.push(lastLocation.pathname);
        }
    }, [confirmedNavigation, lastLocation, history]);

    // Block non-react routes
    useEffect(() => {
        const unload = event => {
            if (!shouldUnload) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = showModal(MODAL_TYPE.UNSAVED_MODIFICATIONS);
            } else {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = '';
            }
        };
        const beforeunloadFunction = function(e) {
            // handle reload - if we refresh page, don't need to show modal
            if (
                // browser might not support window.performance or window.performance.getEntriesByType
                window.performance &&
                window.performance.getEntriesByType &&
                window.performance.getEntriesByType('navigation') &&
                window.performance.getEntriesByType('navigation')[0].type === 'reload'
            ) {
                e.returnValue = '';
                return null;
            }
            return unload(e);
        };
        window.addEventListener('beforeunload', beforeunloadFunction);

        return () => window.removeEventListener('beforeunload', beforeunloadFunction);
    }, [shouldUnload]);

    return (
        <>
            <Prompt when={when} message={handleBlockedRoute} />
        </>
    );
}
